import { gql } from "@grandvisionhq/graphql";
import { ShoppinglistBasicFragment } from "../../../fragments/operations/fragments/shopping-list.js";
const removeFromShoppinglistFragment = gql`
  fragment RemoveFromShoppinglistFragment on RemoveFromShoppinglistSuccessResponse {
    result {
      ...ShoppinglistBasicFragment
    }
  }
  ${ShoppinglistBasicFragment}
`;
const failuresFragment = gql`
  fragment RemoveFromShoppinglistFailureFragment on RemoveFromShoppinglistFailureResponse {
    failures {
      ... on ShoppinglistNotFoundFailure {
        message
      }
      ... on ShoppinglistAuthorizationFailure {
        message
      }
      ... on ShoppinglistValidationFailure {
        message
      }
      ... on ShoppinglistFailure {
        message
      }
    }
  }
`;
const REMOVE_FROM_SHOPPING_LIST = gql`
  mutation RemoveFromShoppinglist($input: RemoveFromShoppinglistInput!) {
    removeFromShoppinglist(input: $input) {
      ...RemoveFromShoppinglistFragment
      ...RemoveFromShoppinglistFailureFragment
    }
  }
  ${removeFromShoppinglistFragment}
  ${failuresFragment}
`;
export {
  REMOVE_FROM_SHOPPING_LIST as default,
  failuresFragment,
  removeFromShoppinglistFragment
};
//# sourceMappingURL=remove-from-shopping-list.js.map
